import "~/misc/common";
import { p } from "~/misc/common";
import "select2/dist/css/select2.css";
import "select2-bootstrap-theme/dist/select2-bootstrap.min.css";
import "~/styles/select2-override.scss";

import select2 from 'select2';
//import 'select2/dist/js/i18n/hu.js'
// @ts-ignore
select2();

// Use the `?raw` suffix to import select2 as a string
//import src from 'select2?raw';

// Manually invoke Select2's UMD factory with jQuery (Vite 7 Rollup doesn't auto-init)
//new Function('module', 'require', 'window', 'jQuery', src)(
//  {}, () => jQuery, window, jQuery
//);

// Now you can use $('#mySelect').select2();

$(() => {
  console.log("select2.ts");
  // @ts-ignore
  import("select2/dist/js/i18n/hu.js").then(() => {
    $(".select2").select2({
      theme: "bootstrap",
      language: "hu",
      width: '100%'
    }).on("select2:unselecting", function (e) {
      $(this).data('unselecting', true);
    }).on('select2:open', function (e) {
      if ($(this).data('unselecting')) {
        $(this).select2('close').removeData('unselecting');
      }
      if ($(window).width() as number < 767) {
        setTimeout(function () {
          p('z-index');
          $('.select2-container.select2-container--bootstrap.select2-container--open').css('z-index', '10002');
        }, 10);
      }
    }).on('select2:opening', function (e) {
      p('select2:opening');
      if ($(window).width() as number < 767) {
        $('#select2overlay').show();
        $('.select2-container--open').css('z-index', '0 !important');
      }
    }).on('select2:closing', function (e) {
      p('select2:closing');
      if ($(window).width() as number < 767) {
        $('.select2-container.select2-container--bootstrap.select2-container--open').css('z-index', 'unset');
        $('#select2overlay').hide();
      }
    });
  });
});
